
const ChatBoxModal = ({ setModalIsOpen, assignedProjects, chatBoxModalRef }) => {
    return (
        <>
            <div 
            ref={chatBoxModalRef}
            style={{
                position: 'absolute',
                top: '74px',
                right: '9px',
                width: '180px',
                background: '#fff',
                borderRadius: '10px',
                padding: '15px'
            }}>
                <i onClick={((e) => {
                    e.stopPropagation();
                    setModalIsOpen(false);
                })} class="fa-solid fa-xmark" style={{
                    position: 'absolute',
                    top: '10px',
                    right: '20px',
                    zIndex: 9999
                }}></i>
                <h6 style={{
                    fontSize: '12px',
                    fontWeight: '500'
                }}>Name of Projects</h6>
                <div style={{
                    height: '120px',
                    overflow: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '8px'
                }}>
                    {/* <p style={{
                        fontSize: '13px',
                        marginBottom: '0px'
                    }}>IGR</p>
                    <p style={{
                        fontSize: '13px',
                        marginBottom: '0px'
                    }}>IGR</p>
                    <p style={{
                        fontSize: '13px',
                        marginBottom: '0px'
                    }}>IGR</p>
                    <p style={{
                        fontSize: '13px',
                        marginBottom: '0px'
                    }}>IGR</p>
                    <p style={{
                        fontSize: '13px',
                        marginBottom: '0px'
                    }}>IGR</p>
                    <p style={{
                        fontSize: '13px',
                        marginBottom: '0px'
                    }}>IGR</p>
                    <p style={{
                        fontSize: '13px',
                        marginBottom: '0px'
                    }}>IGR</p> */}

                    {
                        assignedProjects?.map((project, i) => (
                            <p style={{
                                fontSize: '13px',
                                marginBottom: '0px'
                            }}>{i + 1}. {project}</p>
                        ))
                    }

                </div>

            </div>
        </>
    )
}

export default ChatBoxModal
